export default __webpack_public_path__ + "static/catholicGuy-452fc216caebfe8dec86f7f0f4b46175.svg";